export const formatEntity = (data) => {
  let entity = null
  if (data) {
    entity = {
      id: data.id,
      ...data.attributes,
    }
  }
  return entity
}

export const formatEntities = (data) => {
  let entities = []
  if (data && data.length > 0) {
    entities = data.map((entity) => {
      if (entity.financialAccountId) {
        return formatEntity(entity.data)
      } else {
        return formatEntity(entity)
      }
    })
  }
  return entities
}



// WEBPACK FOOTER //
// ./src/utils/formatter.js